import LoadingSpinner from "@app/shared/LoadingSpinner";
import { MapCustomControlProps } from "@app/shared/mapping/MapCustomControlProps"
import { useMapboxControl } from "@app/shared/mapping/useMapBoxControl";
import { createPortal } from 'react-dom';

export const LoadingSpinnerControl: React.FC<MapCustomControlProps & {isLoading: boolean}> = ({ ignoreInMapExport, mapRef, position, isLoading}) => {

  const container = useMapboxControl({mapRef, position});
  if (!container) return null;

  return createPortal (
    <div {...(ignoreInMapExport ? { 'data-html2canvas-ignore': '' } : {})} className="loading-spinner-control">
      {isLoading && <LoadingSpinner/>}
    </div>,
    container
  )
};